import create from 'zustand';

type CompareModeState = {
    /** Whether the mobile "Sammenlign" mode is active, showing a compare toggle on every card. */
    isActive: boolean;

    actions: {
        setIsActive: (isActive: boolean) => void;
        toggle: () => void;
    };
};

/**
 * On mobile there isn't room to show a compare toggle on every card by default, so it's
 * behind a mode the customer switches on next to the filter button. Desktop shows the
 * toggle on every card regardless of this state.
 *
 * Lives beside the comparison itself rather than in the product list, because the tray -
 * which is shared, and cannot reach into a feature - switches it on when it sends the
 * customer to a category to pick more.
 */
export const useCompareModeStore = create<CompareModeState>((set, get) => ({
    isActive: false,
    actions: {
        setIsActive: (isActive) => set({ isActive }),
        toggle: () => {
            const {
                isActive,
                actions: { setIsActive },
            } = get();
            setIsActive(!isActive);
        },
    },
}));
